import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
export * from './types'

export const plano_governo = {
  namespaced: true,
  state: () => ({
    loading: false,
    compromissos: [],
    loadingSecretaria: false,
    compromissosSecretaria: []
  }),
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/plano_governo/index.js